module.exports = __webpack_public_path__ + "static/img/rys7.033821f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rys7.jpg
// module id = 5qFO
// module chunks = 1